import { IResult } from '@core/interfaces/IResult';

import Patient from './patient.model';
import patientService from './patient.service';

export class PatientStore {
  storageKey = '@PatientStore';

  current?: Patient;
  loadind_current = false;

  items: Patient[] = [];
  loading_items = false;

  errors: string[] = [];

  getItems = () => {
    this.items = [];
    this.loading_items = true;
    this.errors = [];

    patientService.getAll().then(this.setItemsSuccess).catch(this.setItemsFailure);
  };

  setItemsSuccess = (value: Patient[]) => {
    this.items = value;
    this.loading_items = false;
  };

  setItemsFailure = (error: any) => {
    this.items = [];
    this.loading_items = false;
    this.errors = [JSON.stringify(error)];
    console.log(error);
  };

  getById = (id: string) => {
    this.current = undefined;
    this.loadind_current = false;
    this.errors = [];

    patientService.getById(id).then(this.setCurrentSucces).catch(this.setCurrentFailure);
  };

  setCurrentSucces = (value?: Patient) => {
    this.current = value;
    this.loadind_current = false;
  };

  setCurrentFailure = (error: any) => {
    this.current = undefined;
    this.loadind_current = false;
    this.errors = [JSON.stringify(error)];
    console.log(error);
  };

  removeItem = async (id: string): Promise<IResult> => {
    return await patientService
      .remove(id)
      .then(() => {
        this.getItems();
        return { type: 'warning', message: 'Registro excluído com sucesso' } as IResult;
      })
      .catch(error => ({
        type: 'error',
        message: typeof error === 'string' ? error : JSON.stringify(error),
      }));
  };
}
